/**
 *
 *  TimeSlotsItem
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 23/02/2023.
 *  Copyright (c) 2016-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useState } from "react";
import useContentScrollerItem from "../../../hooks/useContentScrollerItem/useContentScrollerItem";

// Hooks
import useTheme from "../../ThemeProvider/useTheme/useTheme";

// Utils
import { clientWidth } from "../../../utils";

const TimeSlotItem = ({
  children,
  contentScrollerApi,
  id,
  isContentScrollerVisible,
  itemKey,
  selected,
  onTimeSlotPress,
  onTimeSlotVisible,
  onTimeSlotVisibleChange,
  preloadCount,
  sharedElementId,
}) => {
  const { theme } = useTheme();

  const [elementRef, setElementRef] = useState(null),
    { isWithinPreloadRange } = useContentScrollerItem({
      contentScrollerApi: contentScrollerApi,
      element: elementRef,
      isScrollerVisible: isContentScrollerVisible,
      key: itemKey,
      onItemVisible: onTimeSlotVisible,
      onItemVisibleChange: onTimeSlotVisibleChange,
      preloadCount: preloadCount,
      threshold: 0.5,
    }),
    // eslint-disable-next-line
    [stateLoaded, setStateLoaded] = useState(true);

  const isVisible =
    itemKey === 0 ||
    stateLoaded ||
    (isWithinPreloadRange && isContentScrollerVisible);

  return (
    <button
      className={`time-slot-item tbk-text-main ${
        clientWidth() < theme.responsive.breakpoints.sm
          ? "tbk-h-[44px]"
          : "tbk-h-4"
      } tbk-h-4 tbk-cursor-pointer tbk-rounded-lg tbk-border tbk-border-solid tbk-outline-none ${
        selected
          ? "tbk-border-coral tbk-bg-coral tbk-text-basic-white md:tbk-border-blue-dark md:tbk-bg-blue-dark"
          : "tbk-border-blue-grey-light tbk-bg-blue-grey-light tbk-text-blue-dark hover:tbk-border-blue-dark md:tbk-bg-grey-light"
      }`}
      aria-checked={selected}
      role="radio"
      style={{
        width:
          clientWidth() < theme.responsive.breakpoints.sm ? "48px" : "76px",
        padding:
          clientWidth() < theme.responsive.breakpoints.sm
            ? "6px 6px"
            : "2px 9px",
      }}
      onClick={onTimeSlotPress}
      ref={setElementRef}
    >
      {isVisible && (
        <div
          className={
            clientWidth() < theme.responsive.breakpoints.sm
              ? "!tbk-leading-none"
              : "tbk-flex tbk-items-baseline tbk-justify-center !tbk-leading-none"
          }
        >
          {children}
        </div>
      )}
    </button>
  );
};

export default TimeSlotItem;
